/* eslint-disable */
import * as React from "react";
import {
  Alert,
  Box,
  Button,
  Typography,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Select,
  FormControl,
  MenuItem,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { red } from "@mui/material/colors";
import { useState } from "react";
import { useEffect } from "react";
import { SharePointFolder, UtilAPI } from "../../services/apigateway";
import Swal from "sweetalert2/dist/sweetalert2.js";
import moment from "moment";
import TextInput from "../TextInput";

export default function RequiredUploadDocuments({
  isEdited,
  objChangeMasterFile,
  financialInfo,
  setObjChangeMasterFile,
  setSelectedOther,
  selectedOther,
  setLoading,
  formView,
  formDisabled,
  validateFields,
  isRequestValid,
  defaultPerformanceBond
}) {
  const errorFileLimitText = "All files size uploaded not over 20MB.";


  const [objPerformanceForm, setObjPerformanceForm] = useState({
    PerformanceBondHeader: "",
    RequestFormItem: {
      Remark: "",
      PerformanceBondItem: "",
    },
  });

  const [selectDefaultPerformanceForm, setSelectDefaultPerformanceForm] = useState("");
  const [listPerformanceBondList, setListPerformanceBondList] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (formView?.AccountId) {
          getSharePointFiles(formView.AccountId);
        }
        const listPerformanceBond = await UtilAPI.getPerformanceBondItems();
        setListPerformanceBondList(listPerformanceBond || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [formView]);

  useEffect(() => {
    if (!formView || !listPerformanceBondList.length) {
      setObjPerformanceForm({
        ...objPerformanceForm,
        PerformanceBondHeader: defaultPerformanceBond,
      });
      setObjChangeMasterFile({
        ...objPerformanceForm,
        PerformanceBondHeader: defaultPerformanceBond,
      });
    } else {
      const newObj = {
        ...formView,
        Remark: formView.ApprovalTrader_Remark,
        PerformanceBondHeader: defaultPerformanceBond || ""
      };

      setObjChangeMasterFile({ RequestFormItem: newObj });

      const perfBondValue = formView?.PerformanceBond || "";
      setObjPerformanceForm({
        RequestFormItem: newObj,
        PerformanceBondHeader: defaultPerformanceBond
      });

      setSelectDefaultPerformanceForm(perfBondValue);
    }

  }, [formView, listPerformanceBondList, defaultPerformanceBond]); // 🔑 รอทั้งสองเงื่อนไข

  useEffect(() => {
    if (validateFields) {
      setRequired({
        fields: "Performance Bond",
        active: true,
      });
    }
  }, [validateFields])

  const [required, setRequired] = useState({
    fields: "",
    active: false,
  });

  const isOverLimilFileSize = (fileSize) => {
    const megabytes = 20;
    const sizeMaximun = megabytes * 1048576;
    const files = objChangeMasterFile.Documents;
    let sizes = [];
    const getSizes = (obj) => {
      for (const key in obj) {
        if (obj[key] !== null && typeof obj[key] === "object") {
          getSizes(obj[key]);
        } else if (key === "Size") {
          sizes.push(obj[key]);
        }
      }
    };

    getSizes(files);
    getSizes(selectedOther);
    let totalSize = 0;
    totalSize = sizes.reduce((sum, size) => sum + size, 0);
    const sumInputFileSize = fileSize + totalSize;
    if (sumInputFileSize >= sizeMaximun) {
      return true;
    } else {
      return false;
    }
  };

  const getFileNameAndSize = (file) => {
    const FileDetails = Array.from(file).map((file) => ({
      name: file.name,
      size: file.size,
    }));

    const FileName = FileDetails[0].name;
    const FileSize = FileDetails[0].size;

    return { FileName, FileSize };
  };

  // function upload other file
  function addFileToUploadList() {
    const attachments2 = document.getElementById("FileOther2").files;
    var fileBuffer = new DataTransfer();
    for (let i = 0; i < attachments2.length; i++) {
      fileBuffer.items.add(attachments2[i]);
    }

    const attachments1 = document.getElementById("FileOther1").files;
    for (let i = 0; i < attachments1.length; i++) {
      fileBuffer.items.add(attachments1[i]);
    }

    let fileNamesChecks = Array.from(attachments1).map((file) => file);
    if (isValidCheckFiles(fileNamesChecks, "FileOther")) {
      document.getElementById("FileOther2").files = fileBuffer.files;
      document.getElementById("FileOther1").files = new DataTransfer().files;

      let newSelectedOther = [];
      for (let i = 0; i < fileBuffer.files.length; i++) {
        newSelectedOther.push({
          Filename: fileBuffer.files[i].name,
          Size: fileBuffer.files[i].size,
        });
      }
      // Update the state to reflect the new files
      setSelectedOther(newSelectedOther); // Assuming setSelectedOther is the state update function
      // setShowTableOther(true);
    }
  }
  function removeFileFromUploadList(indexToRemove) {
    var attachments = document.getElementById("FileOther2").files;
    var fileBuffer = new DataTransfer();

    for (let i = 0; i < attachments.length; i++) {
      if (indexToRemove !== i) fileBuffer.items.add(attachments[i]);
    }

    document.getElementById("FileOther2").files = fileBuffer.files;
    const updatedFiles = selectedOther.filter(
      (_, index) => index !== indexToRemove
    );
    setSelectedOther(updatedFiles);
  }
  function handleChangeFileOther(e) {
    const fileDetail = getFileNameAndSize(e.target.files);
    const isOverLimit = isOverLimilFileSize(fileDetail.FileSize);
    if (isOverLimit) {
      Swal.fire({
        title: errorFileLimitText,
        icon: "error",
        showConfirmButton: true,
      });
    } else {
      addFileToUploadList();
    }
  }

  const [filesSharePoint, setFilesSharePoint] = useState([
    {
      Account_Common_CTR_Others: [],
    },
  ]);

  const getSharePointFiles = async (id) => {
    try {
      const results = await SharePointFolder.getFileByAccount(id);
      const filesSharePoint = results.responseData;

      const mappedFiles = {
        Account_Common_CTR_Others: [],
      };

      filesSharePoint.forEach((folder) => {
        if (mappedFiles.hasOwnProperty(folder.Name)) {
          mappedFiles[folder.Name] = (folder.Files || []).sort(
            (a, b) => new Date(a.TimeCreated) - new Date(b.TimeCreated)
          );
        }
      });

      setFilesSharePoint(mappedFiles);
    } catch (errors) {
      console.error(errors);
    } finally {
      setLoading(false);
    }
  };

  function isValidCheckFiles(file, name) {
    let newFile = file[0];
    // check size
    const maxFileSizeMB = 5;
    const maxFileSizeBytes = maxFileSizeMB * 1024 * 1024;

    // check type
    const acceptedExtensions = [
      ".jpg",
      ".png",
      ".pdf",
      ".xls",
      ".xlsx",
      ".doc",
      ".docx",
    ];
    let fileExtension = newFile.name
      .toLowerCase()
      .substring(newFile.name.lastIndexOf("."));

    if (acceptedExtensions.includes(fileExtension)) {
      document.getElementById(name).innerText = "";
      if (newFile.size < maxFileSizeBytes) {
        document.getElementById(name).innerText = "";
        return true;
      } else {
        document.getElementById(name).innerText =
          "Allow upload file size 5MB per file.";
        return false;
      }
    } else {
      document.getElementById(name).innerText =
        "Allow upload file type: JPG, PNG, PDF, XLS, XLSX, DOC, DOCX";
      return false;
    }
  }

  return (
    <Box sx={{ border: "none" }}>
      {/* form body */}
      <Box>
        {/* title required */}
        <Box sx={{ border: "none" }}>
          <Box sx={{ backgroundColor: "#E1E5ED", fontWeight: "bold", m: 1 }}>
            <label style={{ margin: 4, borderRadius: 5 }}>
              Existing Performance Bond Condition
            </label>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "start",
            }}
          >
            <Box sx={{ p: 1, m: 1, width: "100%" }}>
              <Typography variant="subtitle1">Performance Bond</Typography>
              <FormControl sx={{ minWidth: "49%" }} size="small">
                <Select
                  value={objPerformanceForm.PerformanceBondHeader || ""}
                  onChange={(e) => {
                    const updated = {
                      ...objPerformanceForm,
                      PerformanceBondHeader: e.target.value,
                    };
                    setObjPerformanceForm(updated);
                  }}
                  disabled
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    Select Performance Bond Header
                  </MenuItem>

                  {listPerformanceBondList.map((item, index) => (
                    <MenuItem key={index} value={item.value}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>

              </FormControl>
            </Box>
          </Box>
          <br />
        </Box>

        {/*  Change Performance Bond Condition */}
        <Box sx={{ backgroundColor: "#E1E5ED", fontWeight: "bold", m: 1 }}>
          <label style={{ margin: 4, borderRadius: 5 }}>
            Change Performance Bond Condition
          </label>
        </Box>
        <Box
          sx={{
            p: 1,
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
          }}
        >
          {/* Performance Bond select list*/}
          <Box sx={{ width: "48%", mt: 1 }}>
            <Typography variant="subtitle1">Performance Bond</Typography>
            <FormControl sx={{ minWidth: "45%" }} size="small" className="field-required">
              <Select
                required
                value={
                  formView
                    ? objPerformanceForm?.RequestFormItem?.PerformanceBond
                      ? objPerformanceForm?.RequestFormItem?.PerformanceBond
                      : "PerformanceBondItems"
                    : objPerformanceForm.RequestFormItem.PerformanceBondItem !== ""
                      ? objPerformanceForm.RequestFormItem.PerformanceBondItem
                      : "PerformanceBondItems"
                }
                onChange={(e) => {
                  let obj = Object.assign({}, objPerformanceForm);

                  if (formView) {
                    obj.RequestFormItem.PerformanceBond = e.target.value;
                  } else {
                    obj.RequestFormItem.PerformanceBondItem = e.target.value;
                  }

                  setObjPerformanceForm(obj);
                }}
                disabled={!formDisabled || isRequestValid}
              >
                <MenuItem value={"PerformanceBondItems"} disabled>
                  Select Performance Bond Items
                </MenuItem>
                {listPerformanceBondList &&
                  listPerformanceBondList.map((item, index) => {
                    return (
                      <MenuItem key={index} value={item.value}>
                        {item.label}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
          </Box>

          {/* remark */}
          <Box sx={{ width: "48%", mt: 1 }}>
            <Typography variant="subtitle1">
              {/* <abbr className="slds-required">*</abbr> */}
              Remark
            </Typography>

            <TextInput
              placeholder="Please input remark..."
              value={objPerformanceForm.RequestFormItem.Remark}
              inputProps={{ maxLength: 160 }}
              onChange={(e) => {
                let obj = Object.assign({}, objPerformanceForm);
                obj.RequestFormItem.ApprovalTrader_Remark = e.target.value;
                obj.RequestFormItem.Remark = e.target.value;
                setObjPerformanceForm(obj);
              }}
              disabled={!formDisabled || isRequestValid}
            />
          </Box>
        </Box>
        <br />

        {/* header upload files additional */}
        <Box sx={{ backgroundColor: "#E1E5ED", fontWeight: "bold", m: 1 }}>
          <label style={{ margin: 4, borderRadius: 5 }}>
            Additional Documents for verification
          </label>
        </Box>

        {formDisabled && (
          <Box sx={{ m: 2, mt: 4 }}>
            <strong>File upload conditions:</strong>
            <Box sx={{ ml: 2 }}>
              1. Allow upload file type: JPG, PNG, PDF, XLS, XLSX, DOC, DOCX.{" "}
              <br />
              2. Allow upload file size 5MB per file.
              <br />
              3. All files size uploaded not over 20MB.
            </Box>
          </Box>
        )}

        {/* Upload  Other Documents  */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "start",
          }}
        >
          <Box sx={{ p: 0, m: 2, width: "100%" }}>
            <Typography variant="subtitle1" gutterBottom>
              <Box sx={{ textIndent: 20 }}>
                {/* box-upload */}
                {!isRequestValid && formDisabled && (
                  <Box sx={{ display: "flex", flexDirecttion: "row", mb: 2 }}>
                    <Box className="upload-box">
                      <Box sx={{ textIndent: 0, p: 1 }}>
                        <input
                          type="file"
                          id="FileOther2"
                          variant="outlined"
                          accept=".doc,.docx,.xls,.xlsx,.pdf,.jpg,.jpeg,.png"
                          style={{ display: "none" }}
                        />
                        <input
                          type="file"
                          onChange={handleChangeFileOther}
                          id="FileOther1"
                          variant="outlined"
                          accept=".doc,.docx,.xls,.xlsx,.pdf,.jpg,.jpeg,.png"
                          style={{ display: "none" }}
                          multiple={false}
                        />
                        <label htmlFor="FileOther1">
                          <Button
                            variant="outlined"
                            component="span"
                            disabled={!isEdited}
                            style={{ color: "#2C88D9" }}
                          >
                            Upload File
                          </Button>
                        </label>
                      </Box>
                    </Box>
                    <Box sx={{ ml: 2 }}>
                      <Box sx={{ textIndent: 0, p: 1, pl: 2 }}>
                        <label
                          id="FileOther"
                          style={{
                            color: "red",
                            fontSize: 14,
                            verticalAlign: "sub",
                          }}
                        ></label>
                      </Box>
                    </Box>
                  </Box>
                )}

                {/* table result */}
                <TableContainer component={Paper}>
                  <Table size="small" aria-label="a dense table">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center" width="120px">
                          No.
                        </TableCell>
                        <TableCell align="left" sx={{ fontWeight: "bold" }}>
                          File Name
                        </TableCell>
                        <TableCell align="left">Upload Date/Time</TableCell>
                        <TableCell
                          align="center"
                          width="150px"
                          sx={{ fontWeight: "bold" }}
                        >
                          Delete
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filesSharePoint?.Account_Common_CTR_Others?.map(
                        (item, index) => {
                          if (item) {
                            return (
                              <TableRow key={index}>
                                <TableCell
                                  align="center"
                                  component="th"
                                  scope="row"
                                >
                                  {index + 1}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  component="th"
                                  scope="row"
                                >
                                  <span
                                    className="link-download"
                                    href="name_file"
                                    onClick={(e) => {
                                      e.preventDefault();
                                    }}
                                  >
                                    {item.Name}
                                  </span>
                                </TableCell>
                                <TableCell
                                  align="left"
                                  component="th"
                                  scope="row"
                                >
                                  <span
                                    className="link-download"
                                    href="#!"
                                    onClick={(e) => {
                                      e.preventDefault();
                                    }}
                                  >
                                    {moment(item.TimeCreated).format(
                                      "DD-MMM-YYYY HH:mm a"
                                    )}
                                  </span>
                                </TableCell>
                                <TableCell
                                  align="center"
                                  component="th"
                                  scope="row"
                                >
                                  &nbsp;
                                </TableCell>
                              </TableRow>
                            );
                          } else {
                            return null;
                          }
                        }
                      )}
                      {selectedOther?.map((fileName, index) => {
                        return (
                          <TableRow
                            key={index}
                            sx={{
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                            }}
                          >
                            <TableCell
                              align="center"
                              component="th"
                              scope="row"
                            >
                              -
                            </TableCell>
                            <TableCell align="left" component="th" scope="row">
                              {fileName.Filename}
                            </TableCell>
                            <TableCell align="left" component="th" scope="row">
                              <span
                                className="link-download"
                                href="#!"
                                onClick={(e) => {
                                  e.preventDefault();
                                }}
                              >
                                {moment(new Date()).format(
                                  "DD-MMM-YYYY HH:mm a"
                                )}
                              </span>
                            </TableCell>
                            <TableCell align="center">
                              <ClearIcon
                                sx={{ color: red[500], cursor: "pointer" }}
                                onClick={() => removeFileFromUploadList(index)}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* visible submit update btn */}
      <Button
        id="check-form-data-register"
        style={{
          visibility: "hidden",
        }}
        onClick={() => {
          if (objChangeMasterFile) {
            if (selectedOther.length > 0) {
              objChangeMasterFile.Documents?.Others.push(...selectedOther);
            }
          }
        }}
      >
        submit
      </Button>
      <Button
        id="check-form-data-register-save-draft"
        style={{
          visibility: "hidden",
        }}
        onClick={() => {
          if (objChangeMasterFile) {
            if (selectedOther.length > 0) {
              objChangeMasterFile.Documents?.Others.push(...selectedOther);
            }
          }
        }}
      >
        update
      </Button>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={required.active}
        autoHideDuration={4000}
        onClose={() => {
          setRequired({
            fields: "",
            active: false,
          });
        }}
      >
        <Alert
          onClose={() => {
            setRequired({
              fields: "",
              active: false,
            });
          }}
          variant="filled"
          severity="warning"
        >
          Required Fields <b> {required.fields}</b>
        </Alert>
      </Snackbar>
    </Box>
  );
}
